import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import MCPService from '../../services/MCPService';

export const getMcps = createAsyncThunk('mcps/getMcps', async (workspaceId) => {
    return await MCPService.getMcps(workspaceId);
});

export const createMcps = createAsyncThunk('mcps/createMcps', async (mcps) => {
    return await MCPService.putMcps(mcps);
});

export const deleteMcp = createAsyncThunk('mcps/deleteMcp', async (mcpId) => {
    const obj = await MCPService.deleteMcp(mcpId);
    return obj?._id;
});

const initialState = {
    myMcps: {
        value: [],
        loading: false,
        error: null,
    },
};

export const MCPSlice = createSlice({
    name: 'mcp',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getMcps.pending, (state) => {
                state.myMcps.loading = true;
                state.myMcps.error = null;
            })
            .addCase(getMcps.fulfilled, (state, action) => {
                state.myMcps.loading = false;
                state.myMcps.value = action.payload;
            })
            .addCase(getMcps.rejected, (state, action) => {
                state.myMcps.loading = false;
                state.myMcps.error = action.error.message;
            });

        builder
            .addCase(createMcps.pending, (state) => {
                state.myMcps.loading = true;
                state.myMcps.error = null;
            })
            .addCase(createMcps.fulfilled, (state, action) => {
                state.myMcps.loading = false;
                const incoming = action.payload || [];
                const byId = new Map(state.myMcps.value.map((m) => [m._id, m]));
                for (const m of incoming) byId.set(m._id, m);
                state.myMcps.value = Array.from(byId.values());
            })
            .addCase(createMcps.rejected, (state, action) => {
                state.myMcps.loading = false;
                state.myMcps.error = action.error.message;
            });

        builder
            .addCase(deleteMcp.fulfilled, (state, action) => {
                state.myMcps.value = state.myMcps.value.filter(
                    (m) => m._id !== action.payload,
                );
            })
            .addCase(deleteMcp.rejected, (state, action) => {
                state.myMcps.error = action.error.message;
            });
    },
});

export const selectMcps = (state) => state.mcp.myMcps.value;
export const selectMcpsLoading = (state) => state.mcp.myMcps.loading;
export const selectMcpsError = (state) => state.mcp.myMcps.error;

export default MCPSlice.reducer;
